<script src="http://res.wx.qq.com/open/js/jweixin-1.6.0.js"></script>
<!-- <script>

var _hmt = _hmt || [];
(function() {
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?3d871cc34469d46b321e2215daf0ec89";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();
</script>
<script>
var _hmt = _hmt || [];
(function() {
  var rr = window.location.href.split('/')
  var gid = rr[rr.length-1].substring(1)
  gid = gid.split('&')[0]
  // console.log('111')
  // console.log(gid)
  if (gid!='dA6pmP' && gid!='dA6pmP=') {
    return
  }
  var hm = document.createElement("script");
  hm.src = "https://hm.baidu.com/hm.js?f30d8686e6c5117109c4717244bf8c36";
  var s = document.getElementsByTagName("script")[0]; 
  s.parentNode.insertBefore(hm, s);
})();
</script> -->
<template>
<div>
<div v-if="!((getId=='dA6pmP'||getId=='dA6pmP='||getId=='qHb1cZ'||getId=='qHb1cZ=')&&!dk)" :style="(!dk&&info.id!='b65c01b6e55b4aa38af94c5a83d61672')?'max-width: 42% !important;margin-left: 29%;z-index:4':(!dk&&info.id=='b65c01b6e55b4aa38af94c5a83d61672')?'max-width: 74% !important;margin-left: 13%;':''" >
  
  <div v-if="pageNo == 0 && infoState">
    <!-- <van-nav-bar :title="titleName"  /> -->
    <div class="wrapper" v-if="info.isRotation==1">
      <swiper
        style="width: 100%; height: 100%"
        :options="swiperOption" 
        ref="mySwiper"
      >
        <swiper-slide v-for="item of swiperList" :key="item.id">
          <img class="swiper-img" :src="item" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>


  <img v-if="info.isRotation==0" @click="showModal()" style="width: 100%;" :src="info.defImg" mode="widthFix" />

  <div v-if="!(!dk&&info.id=='b65c01b6e55b4aa38af94c5a83d61672')" class="flex align-center justify-between padding-lr-xs" style="background-repeat:no-repeat;background-size:100% 100%;-moz-background-size:100% 100%;background-image: url(https://quanyouxiang.oss-cn-shanghai.aliyuncs.com/goods/20230628/file1673939487010590720.png);">
    <div class="flex">
      <div class="text-white padding-top-xs" style="font-size: 13px; width: 30px;margin-bottom: 10px;">正在参加</div>
      <div class="text-white " style="margin-top: 1px;"><span style="font-size: 15px;padding: 10px 0;" class=" text-white ">￥</span><span style="font-size: 35px;" class=" text-bold">{{info.groupBuyingPrice/100}}</span> </div>
      <div class="text-white " style="padding-top:25px ;font-size: 12px;margin-left: 7px;"> 限时限量 疯狂抢购</div>
    </div>
    <!-- <div class="flex">
        <div class="text-white padding-lr-xs " style="font-size: 26px;text-decoration:line-through;">￥5555</div>
        <div style="background-color: #fff; height: 25px;width: 4px;margin:10px 5px;"></div>
        <div class="text-white padding-lr-xs " style="  font-size: 26px;">已抢：{{info.soldNum||0}} 件</div>
      </div> -->

    <div>
      <div class="text-red padding-bottom-xs text-center text-sm padding-lr-xs" style="margin-bottom: 5px;"> 距离结束仅剩</div>
      <div class="flex">
        <!-- <div>还剩</div> -->
        <div class="time-item text-bold">{{left_time_list[0]}}</div>
        <div style="color: #000; font-size:10px;">天</div>
        <div class="time-item text-bold">{{left_time_list[1]}}</div>
        <div style="color: #000; font-size:10px;">时</div>
        <div class="time-item text-bold">{{left_time_list[2]}}</div>
        <div style="color: #000; font-size:10px;">分</div>
        <div class="time-item text-bold">{{left_time_list[3]}}</div>
        <div style="color: #000; font-size:10px;">秒</div>
      </div>
    </div>
  </div>

 

<div class="flex grid col-2 margin-top bg-white" v-if="goodsAttributes.length==1">
  <div class=" text-bold text-xl padding text-center " :class="TabCur==0? 'bg-white text-orange on':'text-black'" @click="tabSelect(0)" style="width: 100%;font-weight: 700;">
    {{goodsAttributes[0].key}}
  </div>
</div>
<div class="flex grid col-2 margin-top bg-redler " style="border-radius: 15px 15px 0 0;" v-if="goodsAttributes.length>1">
  <div class=" text-bold text-xl padding text-center bg-redler" :class="TabCur==0? 'bg-white text-orange on':'text-white'" @click="tabSelect(0)" style="font-weight: 700;">
    {{goodsAttributes[0].key}}
  </div>
  <div class="text-bold text-xl padding text-center bg-redler" :class="TabCur==1? 'bg-white text-orange on':'text-white'" @click="tabSelect(1)" style="font-weight: 700;">
    {{goodsAttributes[1].key}} </div>
</div>
<div v-if="TabCur==0 && goodsAttributes.length>0" class=" bg-white ">
  <div  style="padding: 20px 30px 10px 30px;">
    <div class=" text-white text-xl zhuanshu text-center">{{goodsAttributes[0].title||''}}</div>
  </div>
  <div class="flex flex flex-wrap padding-sm">
    <div class="shuxing text-bold text-center " v-for="(item, index) in goodsAttributes[0].values" :key="index"  @click="pageJump('/buyYx',0,index)" >{{item}}</div>
  </div>
  <!-- 详情图 -->
</div>
<!-- 详情 -->
<div v-if="TabCur==1 && goodsAttributes.length>0" class=" bg-white ">
  <div  style="padding: 20px 30px 10px 30px;">
    <div class=" text-white text-xl zhuanshu text-center">{{goodsAttributes[1].title||''}}</div>
  </div>
  <div class="flex flex flex-wrap padding-sm">
    <div class="shuxing text-bold text-center " v-for="(item, index) in goodsAttributes[1].values " :key="index"  @click="pageJump('/buyYx',1,index)" >{{item}}</div>
  </div>
  <!-- <div class="padding "> <text class="text-black text-bold margin-right-xs">时间</text><text> 6 月</text> </div> -->
  <!-- 详情图 -->
</div>


<!-- <div v-if="shopList.length>0" class="bg-white margin-tb-sm yin text-black round-sm padding" style="padding-top: 20px;padding-bottom: 20px;" :style="dk?'':'border-left: 15px solid rgb(50,90,206);border-right: 20px solid rgb(50,90,206);'"> -->
<div v-if="shopList.length>0&&!(!dk&&info.id=='b65c01b6e55b4aa38af94c5a83d61672')" class="bg-white margin-tb-sm yin text-black round-sm padding" style="padding-top: 20px;padding-bottom: 20px;" >
  <div class="flex align-center justify-between  " style="margin-bottom: 15px;">
    <div class="text-black" style="font-size: 17px;font-weight: 500;"><img  style="width: 17px;height: 17px;display: inline-block;margin-bottom: -3px;margin-right: 2px;" src="https://quanyouxiang.oss-cn-shanghai.aliyuncs.com/goods/20230629/file1674293692464369664.png"/>适用门店({{shopList.length}}家)</div>
    <div v-if="shopList.length>1" @click="pageJumpShop" class=" text-cut text-bold " style="font-size: 17px;color: #e54d42;">全部门店 ></div>
  </div>
  <div v-for="(shop, shopIndex) in shopList" :key="shopIndex">
    <div  v-if="shopIndex<3">
      <div class="flex align-center padding-tb-sm half-angle" style="margin-bottom: 10px;margin-top: 16px;">
        <img class="shop-img" :src="shop.shopLogo"/>
        <div class="margin-right-sm" style="text-align: left;">
          <div v-if="dk" class=" text-bold text-cut" style="width: 200px;font-size: 17px;" :style="dk?'':'font-size: 27px;width: 500px;margin-bottom:25px'" >{{shop.shopName}}</div>
          <div v-if="!dk && shop.distance==0" class=" text-bold text-cut" style="width: 200px;font-size: 17px;" :style="dk?'':'font-size: 23px;width: 400px;margin-bottom:25px'" >{{shop.shopName}}</div>
          <div v-if="!dk && shop.distance!=0" class=" text-bold text-cut" style="width: 200px;font-size: 17px;" :style="dk?'':'font-size: 23px;width: 400px;margin-bottom:5px'" >{{shop.shopName}}</div>
          <div v-if="shop.distance==0 && dk" class="text-red text-sm" style="margin-top: 3px;font-size: 15px;"> <text class="cuIcon-locationfill lg "></text>未授权位置信息</div>
          <div v-if="shop.distance!=0" class="text-red text-sm" style="margin-top: 5px;" :style="!dk?'font-size:21px':''"> <text class="cuIcon-locationfill lg "></text>距你{{shop.distance}}km</div>
          <div class="text-gray text-cut text-sm" style="width: 200px;margin-top: 3px;font-size: 15px;" :style="dk?'':'font-size: 23px;width: 400px;'">{{shop.shopAddress}}{{shop.shopDetailAddress}}</div>
        </div>
        <a style="position: absolute;right: 10px;" :href="'https://uri.amap.com/marker?position=' + shop.longitude+','+shop.latitude+'&name='+shop.shopName" >
          <img class="daoh margin-left-sm" src="https://quanyouxiang.oss-cn-shanghai.aliyuncs.com/goods/20230628/file1673949019036192768.png" :style="dk?'':'margin-left:14px'"/>
          <div class="text-red" style="font-size: 10px;width: 60px;margin-left: 3px;margin-top: 3px;">去这里</div>
        </a>
      </div>
      <!-- <a :href="'https://uri.amap.com/marker?position=' + shop.longitude+','+shop.latitude+'&name='+shop.shopName"  style="border-top: 2px dashed #464646 ;" class="flex align-center justify-between padding-top-sm b-top">
        <div class=" flex align-center">
          <div class="text-red radius text-center text-sm" style="padding: 2px 2px; background: #fdeaea;height: 20px; width: 40px;">最近</div>
          <div v-if="shop.distance==0" class=" margin-lr-xs " style="font-size: 13px; color: #525252;"> <img style="width: 15px;height: 15px;display: inline-block;margin-bottom: -3px;" src="img/addr.png"/>未授权位置信息</div>
          <div v-if="shop.distance!=0" class=" margin-lr-xs " style="font-size: 13px; color: #525252;"> <img  style="width: 15px;height: 15px;display: inline-block;margin-bottom: -3px;" src="img/addr.png"/>距你{{shop.distance}}km</div>
        </div>
        <div class=" text-bold " style="color: #525252;">导航 ></div>
      </a> -->
    </div>
  </div>
</div>
<img v-if="info.shopImg&&!(!dk&&info.id=='b65c01b6e55b4aa38af94c5a83d61672')" :src="info.shopImg" mode="widthFix" style="width:100%;"/>
<div class=" bg-white ">
<img style="width: 100%;"  mode="widthFix" v-for="(item, index) in info.goodsDetailImgs" :key="index" :src="item" />
</div>
<!-- 购买列表 -->

<div v-if="!(!dk&&info.id=='b65c01b6e55b4aa38af94c5a83d61672')" class=" bg-white b-b padding text-bold text-black" style="font-size: 21px;"> <span class="cuIcon-lightfill lg text-red"></span> 最新订购</div>
<vueSeamlessScroll v-if="!(!dk&&info.id=='b65c01b6e55b4aa38af94c5a83d61672')" :data="buyList" :class-option="optionHover"  class="seamless-warp" style="margin-top: 10px;">
  <!-- <ul class="item">
    <li v-for="(item, index) in buyList" :key="index"> -->
      <!-- <span class="title" v-text="item.title"></span><span class="date" v-text="item.date"></span> -->
      <div v-for="(item, index) in buyList" :key="index" class="flex bg-white half-angle align-center justify-between" style="margin: 10px 15px;padding: 5px 10px;">
          <div class="flex align-center">
            <img class="paihangimg"  />
            <div class="margin-left-xs text-df text-cut" style="width: 100px;text-align: left;margin-left: 10px;">{{item.name}}</div>
          </div>
          <div class="text-sm"><span class="text-red">{{item.time}}分钟前</span>购买了该产品</div>
        </div>
        <!-- <div style="height: 100px;font-size: 40px;">滑动测试</div> -->
    <!-- </li>
  </ul> -->
</vueSeamlessScroll>

<div v-if="false"  style="margin: 20px 10px;padding: 10px 1px;border-radius: 15px;border: 1px solid #999999;">
  <div class="flex comp">
    <div style="font-weight: 600;font-size: 20px;">公司信息</div>
    <!-- <div>南京客渠邦网络科技有限公司</div> -->
  </div>
  <div class="flex comp">
    <!-- <div>公司信息：</div> -->
    <div style="color: #0081ff;font-size: 18px;">南京客渠邦网络科技有限公司</div>
  </div>
  <div class=" flex comp">
    <div style="font-weight: 600;font-size: 20px;">公司地址</div>
    <!-- <div>南京市鼓楼区云南北路83号1203室</div> -->
  </div>
  <div class=" flex comp">
    <!-- <div>公司地址：</div> -->
    <div style="color: #0081ff;font-size: 18px;">南京市鼓楼区云南北路83号1203室</div>
  </div>
  <div class=" flex comp">
    <div style="font-weight: 600;font-size: 20px;">联系电话</div>
    <!-- <div>025-86545421</div> -->
  </div>
  <div class=" flex comp">
    <!-- <div>联系电话：</div> -->
    <div style="color: #0081ff;font-size: 18px;">025-86545421</div>
  </div>
</div>
<div v-if="!dk&&info.goodsName!='皮下美白更新'&&info.id!='b65c01b6e55b4aa38af94c5a83d61672'" style="margin: 20px 10px;padding: 10px 1px;border-radius: 15px;width: 100%;">
  <div class="flex comp" style="text-align: center;width: 100%;">
    <div style="font-size: 20px;text-align: center;width: 100%;"><span style="color: #999;font-size: 18px;margin-top: 2px;text-align: center;">南京客渠邦网络科技有限公司</span></div>
    <!-- <div >南京客渠邦网络科技有限公司</div> -->
  </div>
</div>
<div v-if="!dk&&info.goodsName=='皮下美白更新'&&info.id!='b65c01b6e55b4aa38af94c5a83d61672'">
<div  style="margin: 20px 10px 0 10px;border-radius: 15px;width: 100%;">
  <div class="flex " style="text-align: center;width: 100%;">
    <div style="font-size: 18px;text-align: center;width: 100%;"><span style="color: #999;font-size: 18px;margin-top: 2px;text-align: center;">欧维美「皮下美白」项目由南京客渠邦网络科技有限公司提供运营支持</span></div>
  </div>
</div>
<div  style="border-radius: 15px;width: 100%;margin-top: 5px;">
  <div class="flex " style="text-align: center;width: 100%;">
    <div style="font-size: 18px;text-align: center;width: 100%;"><span style="color: #999;font-size: 18px;margin-top: 2px;text-align: center;">南通所有线下体验店（美容院）经过严格甄选</span></div>
  </div>
</div>
<div style="border-radius: 15px;width: 100%;margin-top: 5px;">
  <div class="flex " style="text-align: center;width: 100%;">
    <div style="font-size: 18px;text-align: center;width: 100%;color: #999;">美白所需产品指定品牌SNTAKTIV</div>
  </div>
</div>
<div style="border-radius: 15px;width: 100%;margin-top: 5px;">
  <div class="flex " style="text-align: center;width: 100%;">
    <div style="font-size: 18px;text-align: center;width: 100%;color: #999;">所需美业师均由「欧维美」指定</div>
  </div>
</div>
<div style="border-radius: 15px;width: 100%;margin-top: 5px;">
  <div class="flex " style="text-align: center;width: 100%;">
    <div style="font-size: 18px;text-align: center;width: 100%;"><span style="color: #999;font-size: 18px;margin-top: 2px;text-align: center;">24小时售后服务热线：15366166823</span></div>
  </div>
</div>
</div>
<!-- <img :src="EWMUrl" class="qr-code" alt="" /> -->
<div v-if="!dk&&info.goodsName=='皮下美白更新'&&info.id!='b65c01b6e55b4aa38af94c5a83d61672'" style="height: 80px;"></div>
<div style="height: 80px;"></div>

<!-- 购买按钮 -->
<div v-if="dk||info.goodsName!='皮下美白更新'" class="padding-xl " @click="showModal()" style="position: fixed;bottom: 20px;width: 100%; letter-spacing: 2px;" :style="!dk?'max-width: 42% !important;':''">
  <!-- <div class="an_shop text-bold" style="width: 100%; ">立即报名</div> -->
  <img bindtap="showModal" data-target="bottomModal" src="https://quanyouxiang.oss-cn-shanghai.aliyuncs.com/goods/20230628/file1673942477834555392.png" />

</div>
<!-- <div v-if="!dk&&info.goodsName=='皮下美白更新'" class="padding-xl " @click="showModal()" style="position: fixed;bottom: 0px;left:0;width: 100%; letter-spacing: 2px;" >
  <img bindtap="showModal" data-target="bottomModal" src="/img/buy.png" />
</div> -->
<div v-if="!dk&&info.id=='b65c01b6e55b4aa38af94c5a83d61672'" class="padding-xl " @click="showModal()" style="position: fixed;bottom: 0px;left:0;width: 100%; letter-spacing: 2px;" >
  <img bindtap="showModal" data-target="bottomModal" src="/img/buy3.gif" />
</div>
<!-- 底部弹框 -->
<div class="cu-modal bottom-modal" :class="modalName=='bottomModal'?'show':''" @click="hideModal()" v-if="modalName=='bottomModal'">
  <div class="cu-dialog" style="border-radius: 30px 30px 0 0;">
    <div class="bg-white padding-top-xs text-right padding-right-sm">
      <div class="action" @click="hideModal()">
        <text class="cuIcon-close text-white text-bold" style="font-size: 43px;"></text>
      </div>
    </div>
    <div v-if="TabCur==0 && goodsAttributes.length>0" class=" bg-white ">
      <div class=" text-black text-xl text-center">{{goodsAttributes[0].key}}</div>
      <div class="bg-orange round text-xl text-center zhuanshu" style=" margin:20px 30px 0 30px;">{{goodsAttributes[0].title||''}}</div>
      <div class="flex flex-wrap padding-lr-sm ">
        <div class="shuxing text-bold text-center " v-for="(item, index) in goodsAttributes[0].values" :key="index" @click="pageJump('/buyYx',0,index)" >{{item}}</div>
      </div>
      <div style="height: 80px;"></div>
    </div>
    <!-- 详情 -->
    <div v-if="TabCur==1 && goodsAttributes.length>0" class=" bg-white ">
      <div class=" text-black text-xl text-center">{{goodsAttributes[1].key}}</div>
      <div class="bg-orange round text-xl text-center zhuanshu" style=" margin:20px 30px 0 30px;">{{goodsAttributes[1].title||''}}</div>
      <div class=" flex flex-wrap padding-lr-sm">
        <div class="shuxing text-bold text-center " v-for="(item, index) in goodsAttributes[1].values" :key="index"  @click="pageJump('/buyYx',1,index)">{{item}}</div>
      </div>
      <div style="height: 10px;"></div>

    </div>
  </div>
</div>
</div>
</div>

<div v-if="(getId=='dA6pmP'||getId=='dA6pmP='||getId=='qHb1cZ'||getId=='qHb1cZ=')&&!dk" @click="showBig()" :style="(!dk)?'max-width: 74% !important;margin-left: 13%;z-index:4':''" >
  
  <div v-if="pageNo == 0 && infoState">
    <!-- <van-nav-bar :title="titleName"  /> -->
    <div class="wrapper" v-if="info.isRotation==1">
      <swiper
        style="width: 100%; height: 100%"
        :options="swiperOption" 
        ref="mySwiper"
      >
        <swiper-slide v-for="item of swiperList" :key="item.id">
          <img class="swiper-img" :src="item" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>


  <img v-if="info.isRotation==0"  style="width: 100%;" :src="info.defImg" mode="widthFix" />

  <div v-if="!(!dk&&info.id=='b65c01b6e55b4aa38af94c5a83d61672')" class="flex align-center justify-between padding-lr-xs" style="background-repeat:no-repeat;background-size:100% 100%;-moz-background-size:100% 100%;background-image: url(https://quanyouxiang.oss-cn-shanghai.aliyuncs.com/goods/20230628/file1673939487010590720.png);">
    <div class="flex">
      <div class="text-white padding-top-xs" style="font-size: 13px; width: 30px;margin-bottom: 10px;">正在参加</div>
      <div class="text-white " style="margin-top: 1px;"><span style="font-size: 15px;padding: 10px 0;" class=" text-white ">￥</span><span style="font-size: 35px;" class=" text-bold">{{info.groupBuyingPrice/100}}</span> </div>
      <div class="text-white " style="padding-top:25px ;font-size: 12px;margin-left: 7px;"> 限时限量 疯狂抢购</div>
    </div>
    <!-- <div class="flex">
        <div class="text-white padding-lr-xs " style="font-size: 26px;text-decoration:line-through;">￥5555</div>
        <div style="background-color: #fff; height: 25px;width: 4px;margin:10px 5px;"></div>
        <div class="text-white padding-lr-xs " style="  font-size: 26px;">已抢：{{info.soldNum||0}} 件</div>
      </div> -->

    <div>
      <div class="text-red padding-bottom-xs text-center text-sm padding-lr-xs" style="margin-bottom: 5px;"> 距离结束仅剩</div>
      <div class="flex">
        <!-- <div>还剩</div> -->
        <div class="time-item text-bold">{{left_time_list[0]}}</div>
        <div style="color: #000; font-size:10px;">天</div>
        <div class="time-item text-bold">{{left_time_list[1]}}</div>
        <div style="color: #000; font-size:10px;">时</div>
        <div class="time-item text-bold">{{left_time_list[2]}}</div>
        <div style="color: #000; font-size:10px;">分</div>
        <div class="time-item text-bold">{{left_time_list[3]}}</div>
        <div style="color: #000; font-size:10px;">秒</div>
      </div>
    </div>
  </div>

 

<div class="flex grid col-2 margin-top bg-white" v-if="goodsAttributes.length==1">
  <div class=" text-bold text-xl padding text-center " :class="TabCur==0? 'bg-white text-orange on':'text-black'" @click="tabSelect(0)" style="width: 100%;font-weight: 700;">
    {{goodsAttributes[0].key}}
  </div>
</div>
<div class="flex grid col-2 margin-top bg-redler " style="border-radius: 15px 15px 0 0;" v-if="goodsAttributes.length>1">
  <div class=" text-bold text-xl padding text-center bg-redler" :class="TabCur==0? 'bg-white text-orange on':'text-white'" @click="tabSelect(0)" style="font-weight: 700;">
    {{goodsAttributes[0].key}}
  </div>
  <div class="text-bold text-xl padding text-center bg-redler" :class="TabCur==1? 'bg-white text-orange on':'text-white'" @click="tabSelect(1)" style="font-weight: 700;">
    {{goodsAttributes[1].key}} </div>
</div>
<div v-if="TabCur==0 && goodsAttributes.length>0" class=" bg-white ">
  <div  style="padding: 20px 30px 10px 30px;">
    <div class=" text-white text-xl zhuanshu text-center">{{goodsAttributes[0].title||''}}</div>
  </div>
  <div class="flex flex flex-wrap padding-sm">
    <div class="shuxing text-bold text-center " v-for="(item, index) in goodsAttributes[0].values" :key="index"  @click="pageJump('/buyYx',0,index)" >{{item}}</div>
  </div>
  <!-- 详情图 -->
</div>
<!-- 详情 -->
<div v-if="TabCur==1 && goodsAttributes.length>0" class=" bg-white ">
  <div  style="padding: 20px 30px 10px 30px;">
    <div class=" text-white text-xl zhuanshu text-center">{{goodsAttributes[1].title||''}}</div>
  </div>
  <div class="flex flex flex-wrap padding-sm">
    <div class="shuxing text-bold text-center " v-for="(item, index) in goodsAttributes[1].values " :key="index"  @click="pageJump('/buyYx',1,index)" >{{item}}</div>
  </div>
  <!-- <div class="padding "> <text class="text-black text-bold margin-right-xs">时间</text><text> 6 月</text> </div> -->
  <!-- 详情图 -->
</div>


<!-- <div v-if="shopList.length>0" class="bg-white margin-tb-sm yin text-black round-sm padding" style="padding-top: 20px;padding-bottom: 20px;" :style="dk?'':'border-left: 15px solid rgb(50,90,206);border-right: 20px solid rgb(50,90,206);'"> -->
<div v-if="shopList.length>0&&!(!dk&&info.id=='b65c01b6e55b4aa38af94c5a83d61672')" class="bg-white margin-tb-sm yin text-black round-sm padding" style="padding-top: 20px;padding-bottom: 20px;" >
  <div class="flex align-center justify-between  " style="margin-bottom: 15px;">
    <div class="text-black" style="font-size: 17px;font-weight: 500;"><img  style="width: 17px;height: 17px;display: inline-block;margin-bottom: -3px;margin-right: 2px;" src="https://quanyouxiang.oss-cn-shanghai.aliyuncs.com/goods/20230629/file1674293692464369664.png"/>适用门店({{shopList.length}}家)</div>
    <div v-if="shopList.length>1" @click="pageJumpShop" class=" text-cut text-bold " style="font-size: 17px;color: #e54d42;">全部门店 ></div>
  </div>
  <div v-for="(shop, shopIndex) in shopList" :key="shopIndex">
    <div  v-if="shopIndex<3">
      <div class="flex align-center padding-tb-sm half-angle" style="margin-bottom: 10px;margin-top: 16px;">
        <img class="shop-img" :src="shop.shopLogo"/>
        <div class="margin-right-sm" style="text-align: left;">
          <div v-if="dk" class=" text-bold text-cut" style="width: 200px;font-size: 17px;" :style="dk?'':'font-size: 27px;width: 500px;margin-bottom:25px'" >{{shop.shopName}}</div>
          <div v-if="!dk && shop.distance==0" class=" text-bold text-cut" style="width: 200px;font-size: 17px;" :style="dk?'':'font-size: 23px;width: 400px;margin-bottom:25px'" >{{shop.shopName}}</div>
          <div v-if="!dk && shop.distance!=0" class=" text-bold text-cut" style="width: 200px;font-size: 17px;" :style="dk?'':'font-size: 23px;width: 400px;margin-bottom:5px'" >{{shop.shopName}}</div>
          <div v-if="shop.distance==0 && dk" class="text-red text-sm" style="margin-top: 3px;font-size: 15px;"> <text class="cuIcon-locationfill lg "></text>未授权位置信息</div>
          <div v-if="shop.distance!=0" class="text-red text-sm" style="margin-top: 5px;" :style="!dk?'font-size:21px':''"> <text class="cuIcon-locationfill lg "></text>距你{{shop.distance}}km</div>
          <div class="text-gray text-cut text-sm" style="width: 200px;margin-top: 3px;font-size: 15px;" :style="dk?'':'font-size: 23px;width: 400px;'">{{shop.shopAddress}}{{shop.shopDetailAddress}}</div>
        </div>
        <a style="position: absolute;right: 10px;" :href="'https://uri.amap.com/marker?position=' + shop.longitude+','+shop.latitude+'&name='+shop.shopName" >
          <img class="daoh margin-left-sm" src="https://quanyouxiang.oss-cn-shanghai.aliyuncs.com/goods/20230628/file1673949019036192768.png" :style="dk?'':'margin-left:14px'"/>
          <div class="text-red" style="font-size: 10px;width: 60px;margin-left: 3px;margin-top: 3px;">去这里</div>
        </a>
      </div>
      <!-- <a :href="'https://uri.amap.com/marker?position=' + shop.longitude+','+shop.latitude+'&name='+shop.shopName"  style="border-top: 2px dashed #464646 ;" class="flex align-center justify-between padding-top-sm b-top">
        <div class=" flex align-center">
          <div class="text-red radius text-center text-sm" style="padding: 2px 2px; background: #fdeaea;height: 20px; width: 40px;">最近</div>
          <div v-if="shop.distance==0" class=" margin-lr-xs " style="font-size: 13px; color: #525252;"> <img style="width: 15px;height: 15px;display: inline-block;margin-bottom: -3px;" src="img/addr.png"/>未授权位置信息</div>
          <div v-if="shop.distance!=0" class=" margin-lr-xs " style="font-size: 13px; color: #525252;"> <img  style="width: 15px;height: 15px;display: inline-block;margin-bottom: -3px;" src="img/addr.png"/>距你{{shop.distance}}km</div>
        </div>
        <div class=" text-bold " style="color: #525252;">导航 ></div>
      </a> -->
    </div>
  </div>
</div>
<img v-if="info.shopImg&&!(!dk&&info.id=='b65c01b6e55b4aa38af94c5a83d61672')" :src="info.shopImg" mode="widthFix" style="width:100%;"/>
<div class=" bg-white ">
<img style="width: 100%;"  mode="widthFix" v-for="(item, index) in info.goodsDetailImgs" :key="index" :src="item" />
</div>
<!-- 购买列表 -->

<div v-if="!(!dk&&info.id=='b65c01b6e55b4aa38af94c5a83d61672')" class=" bg-white b-b padding text-bold text-black" style="font-size: 21px;"> <span class="cuIcon-lightfill lg text-red"></span> 最新订购</div>
<vueSeamlessScroll v-if="!(!dk&&info.id=='b65c01b6e55b4aa38af94c5a83d61672')" :data="buyList" :class-option="optionHover"  class="seamless-warp" style="margin-top: 10px;">
  <!-- <ul class="item">
    <li v-for="(item, index) in buyList" :key="index"> -->
      <!-- <span class="title" v-text="item.title"></span><span class="date" v-text="item.date"></span> -->
      <div v-for="(item, index) in buyList" :key="index" class="flex bg-white half-angle align-center justify-between" style="margin: 10px 15px;padding: 5px 10px;">
          <div class="flex align-center">
            <img class="paihangimg"  />
            <div class="margin-left-xs text-df text-cut" style="width: 100px;text-align: left;margin-left: 10px;">{{item.name}}</div>
          </div>
          <div class="text-sm"><span class="text-red">{{item.time}}分钟前</span>购买了该产品</div>
        </div>
        <!-- <div style="height: 100px;font-size: 40px;">滑动测试</div> -->
    <!-- </li>
  </ul> -->
</vueSeamlessScroll>

<div v-if="false"  style="margin: 20px 10px;padding: 10px 1px;border-radius: 15px;border: 1px solid #999999;">
  <div class="flex comp">
    <div style="font-weight: 600;font-size: 20px;">公司信息</div>
    <!-- <div>南京客渠邦网络科技有限公司</div> -->
  </div>
  <div class="flex comp">
    <!-- <div>公司信息：</div> -->
    <div style="color: #0081ff;font-size: 18px;">南京客渠邦网络科技有限公司</div>
  </div>
  <div class=" flex comp">
    <div style="font-weight: 600;font-size: 20px;">公司地址</div>
    <!-- <div>南京市鼓楼区云南北路83号1203室</div> -->
  </div>
  <div class=" flex comp">
    <!-- <div>公司地址：</div> -->
    <div style="color: #0081ff;font-size: 18px;">南京市鼓楼区云南北路83号1203室</div>
  </div>
  <div class=" flex comp">
    <div style="font-weight: 600;font-size: 20px;">联系电话</div>
    <!-- <div>025-86545421</div> -->
  </div>
  <div class=" flex comp">
    <!-- <div>联系电话：</div> -->
    <div style="color: #0081ff;font-size: 18px;">025-86545421</div>
  </div>
</div>
<div v-if="!dk&&info.goodsName!='皮下美白更新'&&info.id!='b65c01b6e55b4aa38af94c5a83d61672'" style="margin: 20px 10px;padding: 10px 1px;border-radius: 15px;width: 100%;">
  <div class="flex comp" style="text-align: center;width: 100%;">
    <div style="font-size: 20px;text-align: center;width: 100%;"><span style="color: #999;font-size: 18px;margin-top: 2px;text-align: center;">南京客渠邦网络科技有限公司</span></div>
    <!-- <div >南京客渠邦网络科技有限公司</div> -->
  </div>
</div>
<div v-if="!dk&&info.goodsName=='皮下美白更新'&&info.id!='b65c01b6e55b4aa38af94c5a83d61672'">
<div  style="margin: 20px 10px 0 10px;border-radius: 15px;width: 100%;">
  <div class="flex " style="text-align: center;width: 100%;">
    <div style="font-size: 18px;text-align: center;width: 100%;"><span style="color: #999;font-size: 18px;margin-top: 2px;text-align: center;">欧维美「皮下美白」项目由南京客渠邦网络科技有限公司提供运营支持</span></div>
  </div>
</div>
<div  style="border-radius: 15px;width: 100%;margin-top: 5px;">
  <div class="flex " style="text-align: center;width: 100%;">
    <div style="font-size: 18px;text-align: center;width: 100%;"><span style="color: #999;font-size: 18px;margin-top: 2px;text-align: center;">南通所有线下体验店（美容院）经过严格甄选</span></div>
  </div>
</div>
<div style="border-radius: 15px;width: 100%;margin-top: 5px;">
  <div class="flex " style="text-align: center;width: 100%;">
    <div style="font-size: 18px;text-align: center;width: 100%;color: #999;">美白所需产品指定品牌SNTAKTIV</div>
  </div>
</div>
<div style="border-radius: 15px;width: 100%;margin-top: 5px;">
  <div class="flex " style="text-align: center;width: 100%;">
    <div style="font-size: 18px;text-align: center;width: 100%;color: #999;">所需美业师均由「欧维美」指定</div>
  </div>
</div>
<div style="border-radius: 15px;width: 100%;margin-top: 5px;">
  <div class="flex " style="text-align: center;width: 100%;">
    <div style="font-size: 18px;text-align: center;width: 100%;"><span style="color: #999;font-size: 18px;margin-top: 2px;text-align: center;">24小时售后服务热线：15366166823</span></div>
  </div>
</div>
</div>
<!-- <img :src="EWMUrl" class="qr-code" alt="" /> -->
<div v-if="!dk&&info.goodsName=='皮下美白更新'&&info.id!='b65c01b6e55b4aa38af94c5a83d61672'" style="height: 80px;"></div>
<div style="height: 80px;"></div>

<!-- 购买按钮 -->
<div v-if="dk||info.goodsName!='皮下美白更新'" class="padding-xl " @click="showModal()" style="position: fixed;bottom: 20px;width: 100%; letter-spacing: 2px;" :style="!dk?'max-width: 42% !important;':''">
  <!-- <div class="an_shop text-bold" style="width: 100%; ">立即报名</div> -->
  <img bindtap="showModal" data-target="bottomModal" src="https://quanyouxiang.oss-cn-shanghai.aliyuncs.com/goods/20230628/file1673942477834555392.png" />

</div>
<!-- <div v-if="!dk&&info.goodsName=='皮下美白更新'" class="padding-xl " @click="showModal()" style="position: fixed;bottom: 0px;left:0;width: 100%; letter-spacing: 2px;" >
  <img bindtap="showModal" data-target="bottomModal" src="/img/buy.png" />
</div> -->
<div v-if="!dk&&info.id=='b65c01b6e55b4aa38af94c5a83d61672'" class="padding-xl " style="position: fixed;bottom: 0px;left:0;width: 100%; letter-spacing: 2px;" >
  <img bindtap="showModal" data-target="bottomModal" src="/img/buy4.png" />
</div>
<!-- 底部弹框 -->
<div class="cu-modal bottom-modal" :class="modalName=='bottomModal'?'show':''" @click="hideModal()" v-if="modalName=='bottomModal'">
  <div class="cu-dialog" style="border-radius: 30px 30px 0 0;">
    <div class="bg-white padding-top-xs text-right padding-right-sm">
      <div class="action" @click="hideModal()">
        <text class="cuIcon-close text-white text-bold" style="font-size: 43px;"></text>
      </div>
    </div>
    <div v-if="TabCur==0 && goodsAttributes.length>0" class=" bg-white ">
      <div class=" text-black text-xl text-center">{{goodsAttributes[0].key}}</div>
      <div class="bg-orange round text-xl text-center zhuanshu" style=" margin:20px 30px 0 30px;">{{goodsAttributes[0].title||''}}</div>
      <div class="flex flex-wrap padding-lr-sm ">
        <div class="shuxing text-bold text-center " v-for="(item, index) in goodsAttributes[0].values" :key="index" @click="pageJump('/buyYx',0,index)" >{{item}}</div>
      </div>
      <div style="height: 80px;"></div>
    </div>
    <!-- 详情 -->
    <div v-if="TabCur==1 && goodsAttributes.length>0" class=" bg-white ">
      <div class=" text-black text-xl text-center">{{goodsAttributes[1].key}}</div>
      <div class="bg-orange round text-xl text-center zhuanshu" style=" margin:20px 30px 0 30px;">{{goodsAttributes[1].title||''}}</div>
      <div class=" flex flex-wrap padding-lr-sm">
        <div class="shuxing text-bold text-center " v-for="(item, index) in goodsAttributes[1].values" :key="index"  @click="pageJump('/buyYx',1,index)">{{item}}</div>
      </div>
      <div style="height: 10px;"></div>

    </div>
  </div>
</div>
</div>
</div>

<img v-if="!dk&&info.id!='b65c01b6e55b4aa38af94c5a83d61672'" src="/img/bg.jpg" style="width: 100%;height: 100%;z-index: 1;position: fixed;top: 0;"/>
<img v-if="!dk&&info.goodsName=='皮下美白更新'&&info.id!='b65c01b6e55b4aa38af94c5a83d61672'" @click="showModal()" src="/img/right.png" style="width: 19%;z-index: 2;position: fixed;top: 23%;right: 1%;"/>
<!-- <img v-if="getId=='dA6pmP'||getId=='dA6pmP='||getId=='qHb1cZ='||getId=='qHb1cZ'"  src="/img/saoma.png" style="width: 11%;z-index: 2;position: fixed;top: 15%;right: 1%;"/> -->
<img v-if="getId=='dA6pmP'||getId=='dA6pmP='||getId=='qHb1cZ='||getId=='qHb1cZ'" @click="showBig()" src="/img/sml.png" style="width: 11%;z-index: 2;position: fixed;top: 17%;left: 1%;"/>
<!-- <div @click="showBig()" style="position: fixed;width: 100%;height: 100%;top: 0;z-index: 1;"></div>-->
<!-- <img v-if="getId=='dA6pmP'||getId=='dA6pmP='||getId=='qHb1cZ='||getId=='qHb1cZ'" @click="showBig()" src="/img/smr.png" style="width: 11%;z-index: 2;position: fixed;top: 17%;right: 1%;"/> -->
<!-- <img v-if="showEwm"  src="/img/888.jpg" style="width: 50%;z-index: 99;position: fixed;top: 20%;right: 25%;"/>
<div v-if="showEwm" @click="hideBig()"  style="width: 100%;height: 100%;;z-index: 9;position: fixed;top: 0;right: 0;background: #000;opacity: 0.2;"></div>
<img v-if="showEwm" @click="hideBig()" src="/img/close.png" style="width: 3%;z-index: 100;position: fixed;top: 17%;right: 23%;color: #999999;"/> -->
</div>
</template>
<script>
var _hmt = _hmt || [];
import wx from 'weixin-js-sdk'
import vueSeamlessScroll from 'vue-seamless-scroll'
import QRCode from 'qrcode'
import axios360 from 'axios'
import md5 from 'js-md5';

export default {
  
  name: 'yx',
  components: {
    vueSeamlessScroll
  },
  data () {
    return {
      infoState: false,
      getId: '',
      swiperOption: {
        pagination: ".swiper-pagination",
        //修改分页器样式 ,
        bulletClass: "my-swiper-pagination-bullet",
        //激活样式
        bulletActiveClass: "my-bullet-active",
        //属性设置 自动轮播
        autoplay: true,
        speed: 3000,
        setWrapperSize: true,
        autoHeight: true,
        paginationClickable: true,
        mousewheelControl: true,
        observeParents: true,
        loop: true,
      },
      requestHeadUrl: 'https://zhenqing.kequbang.com',
      // requestHeadUrl: 'http://localhost:8122',
      isOpenVipModular: false,
      isVip: 0,
      storeId: '',
      userId: '',
      isMiniProgram: true,
      appLink: '',
      info: {},
      goodsAttributes: [],
      TabCur:0,
      modalName: '',
      pageNo: 0,
      goodsName: '',
      title: '',
      values: '',
      valueKey: '',
      price: '',
      userPhone: '',
      titleName: '',
      shopList:[],
      lat:'',
      lon:'',
      swiperList: ['https://publicideo.oss-accelerate.aliyuncs.com/9442b761669.png','https://publicideo.oss-accelerate.aliyuncs.com/cb44e761687.png'],
      left_time: '', //活动剩余时间的秒数
      timer: '', //倒计时定时器
      left_time_list: [], //剩余秒数转换 天，小时 分 秒
      left_time_list_date: [],
      buyList: [1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1,1],
      wxCode: '',
      EWMUrl: '',
      dk : true,
      showEwm: false,
      isShow: false,
      footId: '',
    }
  },
  computed: {
    optionHover () {
      return {
        hoverStop: false, //是否开启鼠标悬停stop
        step: 0.5, // 数值越大速度滚动越快
        limitMoveNum: 3, // 开始无缝滚动的数据量 this.dataList.length
        direction: 1, // 0向下 1向上 2向左 3向右
        openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0, // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0, // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)
      }
    }
  },
  created () {
    const thisObj = this
    var href = window.location.href
   
    thisObj.onLoad()
    thisObj.setBuyList()
    let userAgentInfo = navigator.userAgent;
    let Agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
    let getArr = Agents.filter(i => userAgentInfo.includes(i));
    // true： 移动端 false： pc端
    thisObj.dk = getArr.length ? true : false;
    window.addEventListener("unload", (e) => this.unloadHandler(e));
    thisObj.getIPAddress()
    setTimeout(function () {
      if (!thisObj.isShow) {
        thisObj.showEwm = true
      }
    }, 10000)
    // location.href = 'weixin://wxpay/bizpayurl?pr=AX75YBQzz'
    // let canvas = document.createElement('canvas')
    // // 用 canvas 对象和邀请链接生成二维码，并将生成的二维码转为 base64
    // QRCode.toCanvas(canvas, "weixin://wxpay/bizpayurl?pr=SDG98Upzz", (error) => {
    //   if (error) {
    //     //   console.log(error)
    //   } else {
    //     this.EWMUrl = canvas.toDataURL('image/jpeg')
    //   }
    // })
  },
  methods: {
    onLoad: function () {
      
      // const payParam = {
      //       appId: 'wxa55c200673db6dc7',
      //       package: 'result.resultData.package',
      //       paySign: 'result.resultData.sign',
      //       signType: 'MD5',
      //       timeStamp: 'result.resultData.timeStamp',
      //       nonceStr: 'result.resultData.nonceStr'
      //     }
      // this.navigateToMiniProgram(JSON.stringify(payParam))
      var rr = window.location.href.split('/')
      //9d03442a91c345709dcbcd85daab9cc4
      // var gid = rr[rr.length-1].split('-')[0]
      // console.log('rr：' + rr)
      var gid = rr[rr.length-1].substring(1)
      gid = gid.split('&')[0]
      // console.log('gid：' + gid)
      var wx = window.navigator.userAgent.toLowerCase();
      let params = this.$route.query;
      if (wx.match(/MicroMessenger/i) == 'micromessenger'){
        if (params.code==null || params.code==undefined || params.code=='') {
          location.href="https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxd5ba93934e0b0e5b&redirect_uri=https://zxy.kqbang.cn/?"+ gid + "&response_type=code&scope=snsapi_base&state=111#wechat_redirect"
          return;
        } else {
          this.wxCode = params.code
          // alert(params.code)
        }
      }
      //  else {
      //   if (params.state!='1') {
      //     location.href = window.location.href + '&state=1'
      //   }
      // }
      this.$root.qhclickid = params.qhclickid
      this.$root.sourceid = params.sourceid
      const thisObj = this
      thisObj.getId = gid
      thisObj.$api.get(thisObj.requestHeadUrl + '/admin/goodsLink/getById?id='+ gid +'&storeId=storezhenqing&linkId='+rr[rr.length-1], {}).then(res => {
        // console.log(res)
        res.goodsImgs = res.goodsImgs.split(",");
        res.goodsDetailImgs = res.goodsDetailImgs.split(",");
        thisObj.info = res 
        thisObj.goodsAttributes = JSON.parse(res.goodsAttributes)
        thisObj.titleName = res.goodsName
        document.title= res.goodsName
        thisObj.infoState = true
        // if (res.id=='b65c01b6e55b4aa38af94c5a83d61672') {
        //   (function() {
        //     var hm = document.createElement("script");
        //     hm.src = "https://hm.baidu.com/hm.js?3d871cc34469d46b321e2215daf0ec89";
        //     var s = document.getElementsByTagName("script")[0]; 
        //     s.parentNode.insertBefore(hm, s);
        //   })();
        //   (function() {
        //     var hm = document.createElement("script");
        //     hm.src = "https://hm.baidu.com/hm.js?f30d8686e6c5117109c4717244bf8c36";
        //     var s = document.getElementsByTagName("script")[0]; 
        //     s.parentNode.insertBefore(hm, s);
        //   })();
        //   (function() {
        //     var hm = document.createElement("script");
        //     hm.src = "https://hm.baidu.com/hm.js?c86cbd8351543f94cf0474631bf4969c";
        //     var s = document.getElementsByTagName("script")[0]; 
        //     s.parentNode.insertBefore(hm, s);
        //   })();
        // }
        this.getLongitudeLatitude()
        // console.log(res.endTime.replace("-","/")+":00")
        this.getLeftTime(res.endTime.replace("-","/")+":00")
        this.swiperList = res.goodsImgs;
        console.log(this.swiperList)
        // console.log(thisObj.info)
        // console.log(thisObj.goodsAttributes)
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
      thisObj.addFoot()
      thisObj.post360()
    },
    
    unloadHandler() {
      this.leaveFoot()
    },
    getIPAddress() {
      const thisObj = this
      const url = 'http://api.ipify.org?format=json';
      // thisObj.$api.get(url).then(response => {
      //   this.ipAddress = response.data.ip;
      //   console.log('ip：' + this.ipAddress)
      // });
      // thisObj.$api.get(url, {}).then(res => {
      //   console.log(res)
      //   // thisObj.footList = res.records
      // }).catch(function (error) {
      //   thisObj.$util.requetServerError(error)
      // })
    },
    toBaidu() {
    //   var script = document.createElement("script");
    //   script.src = 'your_script_file_url';
    //   document.getElementsByTagName("head")[0].appendChild(script);
      // var _hmt = _hmt || [];
      // (function() {
      //   console.log('123321')
      //   var hm = document.createElement("script");
      //   hm.src = "https://hm.baidu.com/hm.js?3d871cc34469d46b321e2215daf0ec89";
      //   document.getElementsByTagName("head")[0].appendChild(hm);
      //   var s = document.getElementsByTagName("script")[0]; 
      //   s.parentNode.insertBefore(hm, s);
      // })();
      // var _hmt = _hmt || [];
      // (function() {
      //   console.log('123321')
      //   var hm = document.createElement("script");
      //   hm.src = "https://hm.baidu.com/hm.js?3d871cc34469d46b321e2215daf0ec89";
      //   // console.log(hm)
      //   var s = document.getElementsByTagName("script")[0]; 
      //   // console.log(s)
      //   s.parentNode.insertBefore(hm, s);
      // })();
    },
    getLongitudeLatitude() {
      var that = this
      //如果该对象存在，那么地理位置服务可用。
      if ('geolocation' in navigator) {
        /* 地理位置服务可用 */
        var options = {
          enableHighAccuracy: true, //布尔值，表示系统是否使用最高精度来表示结果，注意，这会导致较慢的响应时间或者增加电量消耗（比如对于支持gps的移动设备来说）。如果值为false ，设备会通过更快响应以及/或者使用更少的电量等方法来尽可能的节约资源。默认值fasle
          timeout: 5000, //它表明的是设备必须在多长时间（单位毫秒）内返回一个位置。默认直到获取到位置才会返回值。
          maximumAge: 0 //表明可以返回多长时间（即最长年龄，单位毫秒）内的可获取的缓存位置。如果设置为 0, 说明设备不能使用一个缓存位置，而且必须去获取一个真实的当前位置。默认0
        }
        function success(position) {
          
          //position.coords (只读) 返回一个定义了当前位置的Coordinates对象。
          //position.timestamp (只读) 返回一个时间戳DOMTimeStamp， 这个时间戳表示获取到的位置的时间。
          var lat = position.coords.latitude //当前位置的纬度
          var lon = position.coords.longitude //当前位置精度
          that.lat = lat
          that.lon = lon
          that.getShops()
          // alert(lat + "A233A" + lng)
        }
        function error(err) {
          console.log(err)
          var errorType = ['您拒绝共享位置信息', '获取不到位置信息', '获取位置信息超时']
          console.log(errorType[err.code - 1])
          // alert(errorType[err.code - 1])
          that.getShops()
        }
 
        navigator.geolocation.getCurrentPosition(success, error, options)
      } else {
        /* 地理位置服务不可用 */
        console.log('无法获取您的位置，请检查定位是否开启或刷新重试')
      }
    },
    showBig() {
      const thisObj = this
      thisObj.isShow = true
      thisObj.showEwm = true
      location.href='https://affim.baidu.com/cps5/chatIndex?siteToken=c86cbd8351543f94cf0474631bf4969c&speedLogId=169078686847571ba_1690786868475_19255&bid=169052418254259719&eid=45844456&reqParam={"from"%3A0,"sid"%3A"-100","tid"%3A"-1","ttype"%3A1,"siteId"%3A"19460328","userId"%3A"45844456","pageId"%3A0}'
    },
    hideBig() {
      const thisObj = this
      thisObj.showEwm = false
    },
    getShops() {
      const thisObj = this
      thisObj.$api.get(thisObj.requestHeadUrl + '/group/shop/getAllShopsByGoods?lat='+ thisObj.lat +'&lon='+ thisObj.lon +'&goodsId='+thisObj.info.id, {}).then(res => {
        // console.log(res)
        thisObj.shopList = res
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },
    addFoot() {
      const thisObj = this
      var fullPath = window.location.href
      thisObj.$api.get(thisObj.requestHeadUrl + '/admin/goodsLink/addFoot?getId='+ thisObj.getId +'&fullPath='+ fullPath, {}).then(res => {
        // console.log(res)
        thisObj.footId = res
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },
    leaveFoot() {
      const thisObj = this
      thisObj.$api.get(thisObj.requestHeadUrl + '/admin/goodsLink/updateFootEnd?id='+ thisObj.footId, {}).then(res => {
        // console.log(res)
        // thisObj.shopList = res
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },
    post360() {
      const thisObj = this
      return;
      // console.log(md5('123456'))
      var data = {
        data: {
          data_industry: 'ocpc_zs_convert',
          data_detail: {
            qhclickid: '9356596331006111412',
            jzqs: '1232335',
            event: 'REGISTERED'
          }
        }
      }
      var ds = encodeURIComponent(JSON.stringify(data));
      //make sign
      var sign = md5('ilgb377679xifhfpp88jd4brw9d42hfu'+ds);
      console.log(sign)
      // return
      axios360.create({
        timeout: 5000, // request timeout
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
          'App-Key': '3qw5rjo8x09z3a46jtcx',
          'App-Sign' : sign,
        },
      })
      axios360.post('https://convert.dop.360.cn/uploadWebConvert', data,{headers:{
          'Content-Type': 'application/json;charset=utf-8',
          'App-Key': '3qw5rjo8x09z3a46jtcx',
          'App-Sign' : sign,
        }}).then(res => {
        console.log(res)
        // thisObj.shopList = res
      }).catch(function (error) {
        thisObj.$util.requetServerError(error)
      })
    },

    goApp() {
      location.href=this.appLink
    },
    tabSelect(e) {
      this.TabCur = e
    },
    showModal() {
      const thisObj = this
      var that = this;
      var info = that.info
      var goodsAttributes = that.goodsAttributes
      if (goodsAttributes.length<1) {
        thisObj.userPhone = ''
        let queryData = {
          goodsName: info.goodsName,
          type:1,
          price: info.groupBuyingPrice,
          valueKey: info.notes,
          oldPrice: info.buyPrice,
          wxCode: that.wxCode,
          getId: that.getId,
          introduceImg:info.introduceImg
        }
        thisObj.leaveFoot()
        thisObj.$router.push({
          path: '/buyYx',
          query: queryData
        })
        return
      }
      this.modalName = 'bottomModal'
    },
    hideModal() {
      this.modalName = ''
    },
    // 页面跳转
    pageJump (uri, obj,index) {
      const thisObj = this
      var that = this;
    var info = that.info
    var goodsAttributes = that.goodsAttributes
      
    // thisObj.goodsName = info.goodsName
    // thisObj.title = goodsAttributes[obj].title
    // thisObj.values = goodsAttributes[obj].values[index]
    // thisObj.valueKey = goodsAttributes[obj].valueKey[index]
    // thisObj.price = info.groupBuyingPrice
    // thisObj.pageNo = 1
    thisObj.userPhone = ''
      let queryData = {
        goodsName: info.goodsName,
        title: goodsAttributes[obj].title,
        values: goodsAttributes[obj].values[index],
        valueKey: goodsAttributes[obj].valueKey[index],
        price: info.groupBuyingPrice,
        oldPrice: info.buyPrice,
        wxCode: that.wxCode,
        getId: that.getId,
        introduceImg: goodsAttributes[obj].imgValue[index]
      }
      thisObj.leaveFoot()
      thisObj.$router.push({
        path: uri,
        query: queryData
      })
    },
    pageJumpShop (uri, obj,index) {
      const thisObj = this
      var that = this;
    var info = that.info
    var goodsAttributes = that.goodsAttributes

    // thisObj.goodsName = info.goodsName
    // thisObj.title = goodsAttributes[obj].title
    // thisObj.values = goodsAttributes[obj].values[index]
    // thisObj.valueKey = goodsAttributes[obj].valueKey[index]
    // thisObj.price = info.groupBuyingPrice
    // thisObj.pageNo = 1
    // thisObj.userPhone = ''
      let queryData = {
        goodsId: info.id,
        lon: that.lon,
        lat: that.lat,
      }
      thisObj.$router.push({
        path: '/yxShop',
        query: queryData
      })
    },
    onClickLeft () {
      this.pageNo = 0
    },
    // 页面跳转
    pageJumpCate (uri) {
      const thisObj = this
      let queryData = {
      }
      thisObj.$router.push({
        path: uri, 
        query: queryData
      })
    },
    setBuyList() {
      this.buyList= [{name:'王*',time:1},{name:'张*里',time:1},{name:'王*和',time:2},
      {name:'李*',time:3},{name:'赵*极',time:3},{name:'王*',time:3},{name:'张*',time:4},
      {name:'沈*',time:5},{name:'刘*',time:10},{name:'李*芝',time:10},{name:'赵*',time:11}]
    },
    /**
   * 定时器，计算剩下时间
   * @param {*} end_time 
   */
  getLeftTime(end_time) {
    let left_time = this.getTimestap(end_time);
    this.initDate(left_time)
    this.timer = setInterval(() => {
      if (left_time-- === 0) {
        this.left_time = 0
        this.left_time_list = this.formatSeconds(0)
        clearInterval(this.timer)
      } else {
        this.initDate(left_time)
      }
    }, 1000);
  },  
  /**
  * 初始化数据
    */
  initDate(e) {
    var that = this
    that.left_time_list = that.formatSeconds(e),
    that.left_time_list_date = that.formatDate(JSON.stringify(that.left_time_list));
    that.left_time = e
  },
  /**
    * 获取指定时间-当前时间的秒数
    * @param {*} end_time 
    */
  getTimestap(end_time) {
    // 当前时间
    var currentTime = parseInt(new Date().getTime() / 1000);
    // 未来时间
    var futureTime = parseInt(new Date(end_time.replace(/-/g, '/')).getTime() / 1000); //ios无法解析
    return futureTime <= currentTime ? 0 : futureTime - currentTime;
  },/**
  * 毫秒-天-时-分-秒
  * @param {*} value 
  */
  formatSeconds(value) {
    let time = [],
      day = parseInt(value / 86400),
      hour = parseInt((value % 86400) / 3600),
      min = parseInt(((value % 86400) % 3600) / 60),
      sec = parseInt(((value % 86400) % 3600) % 60);
    time[0] = day > 0 ? this.addZero(day) : this.addZero(0);
    time[1] = hour > 0 ? this.addZero(hour) : this.addZero(0);
    time[2] = min > 0 ? this.addZero(min) : this.addZero(0);
    time[3] = sec > 0 ? this.addZero(sec) : this.addZero(0);
    return time;
  },
  /**
   * 拆分数组-天-时-分-秒
   * @param {*} e 
   */
  formatDate(e) {
    let list = JSON.parse(e);
    for (let i = 0; i < list.length; i++) {
      list[i] = list[i].toString().split('');
    }
    return list;
  },
  /**
   * 补0
   * @param {*} num 
   */
  addZero(num) {
    return num < 10 ? "0" + num : num;
  },
    
  }
}
</script>

<style>
.bg-e {
  background: #eeeeee;
}
.margin-top {
    margin-top: 30px;
}
.grid {
    display: flex;
    flex-wrap: wrap;
}
.justify-between {
    justify-content: space-between;
}
.align-center {
    align-items: center;
}
.text-xxl {
    font-size: 44px;
}
.margin {
    margin: 30px;
}
.bg-white {
    background-color: var(--white);
    color: var(--darkGray);
}
.padding {
    padding: 30px;
}
.text-cut {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
}
.text-xl {
    font-size: 36px;
}
.flex {
    display: flex;
}
.grid.col-2>div {
    width: 50%;
}
.text-orange, .line-orange, .lines-orange {
    color: #f37b1d;
}
.text-center {
    text-align: center;
}
.text-bold {
    font-weight: bold;
}
.text-xl {
    font-size: 36px;
}
.bg-white {
    background-color: #ffffff;
    color: #666666;
}
.padding {
    padding: 30px;
}
.padding-top {
    padding-top: 30px;
}
.b-b {
    border-bottom: 2px solid #CFCFCF;
}
.padding-sm {
    padding: 20px;
}
.flex-wrap {
    flex-wrap: wrap;
}
.flex {
    display: flex;
}
.text-bold {
    font-weight: bold;
}
.text-orange, .line-orange, .lines-orange {
    color: #f37b1d;
}
.cu-modal.bottom-modal.show {
    margin-bottom: 0;
}
.on {
  font-size: 36px;
  border-radius: 20px 20px 0 0;
}
.padding-right-sm {
    padding-right: 20px;
}
.padding-top-xs {
    padding-top: 10px;
}
.bg-orange {
    background-color: #f37b1d;
    color: #ffffff;
}
.an_shop {
  width: 100%;
  line-height: 130px;
  color: #fff;
  background-color: #ec3636;
  border-radius: 30px;
  text-align: center;
  font-size: 48px;
  height: 130px;
}
.onno {
  font-size: 40px;
  border-radius: 30px;
}

.an_shop2 {
  width: 40%;
  line-height: 80px;
  color: #fff;
  background-color: #ff6600;
  border-radius: 50px;
  text-align: center;
  font-size: 36px;
}
.on {
  font-size: 36px;
  border-radius: 20px 20px 0 0;
}

.shuxing {
  color: #f53434;
  font-size: 29px;
  width: 29%;
  margin: 12px;
  border-radius: 20px;
  padding: 20px 8px;
  margin-top: 30px;
  background-color: #ffefe4;
  border: 2px solid #f53434;
}
.bg-redler {
    background-color: #ffc0c0;
}
.half-angle {
    box-shadow: 1px 2px 18px 0px rgba(0, 0, 0, 0.12);
    border-radius: 40px;
}
.margin-top-sm {
    margin-top: 20px;
}
.margin-top-xs {
    margin-top: 10px;
}
.padding-top-sm {
    padding-top: 20px;
}

.cu-modal.show {
    opacity: 1;
    transition-duration: 0.3s;
    -ms-transform: scale(1);
    transform: scale(1);
    overflow-x: hidden;
    overflow-y: auto;
    pointer-events: auto;
}
.cu-modal {
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    z-index: 1110;
    opacity: 0;
    outline: 0;
    text-align: center;
    -ms-transform: scale(1.185);
    transform: scale(1.185);
    backface-visibility: hidden;
    perspective: 2000px;
    background: rgba(0, 0, 0, 0.6);
    transition: all 0.3s ease-in-out 0s;
    pointer-events: none;
}
.cu-modal.bottom-modal.show {
    margin-bottom: 0;
}
.cu-modal.bottom-modal::before {
    vertical-align: bottom;
}
.cu-modal::before {
    content: "\200B";
    display: inline-block;
    height: 100%;
    vertical-align: middle;
}
.cu-modal.bottom-modal .cu-dialog {
    width: 100%;
    border-radius: 0;
}
.cu-dialog {
    position: relative;
    display: inline-block;
    vertical-align: middle;
    margin-left: auto;
    margin-right: auto;
    width: 680px;
    max-width: 100%;
    background-color: #f8f8f8;
    border-radius: 10px;
    overflow: hidden;
}
.text-right {
    text-align: right;
}
.bg-white {
    background-color: #ffffff;
    color: #666666;
}
.padding-right-sm {
    padding-right: 20px;
}
.padding-top-xs {
    padding-top: 10px;
}
.cuIcon-close:before {
    content: "\e646";
}
.text-black, .line-black, .lines-black {
    color: #333333;
}
.text-bold {
    font-weight: bold;
}
.text-center {
    text-align: center;
}
.text-xl {
    font-size: 36px;
}
.bg-orange {
    background-color: #f37b1d;
    color: #ffffff;
}
.flex-wrap {
    flex-wrap: wrap;
}
.flex {
    display: flex;
}
.padding-lr-sm {
    padding-left: 20px;
    padding-right: 20px;
}
.round {
    border-radius: 500px;
}





button.tools-item {
  line-height: 1.1;
  margin: 0;
  padding: 0;
  background: transparent;
  font-size: 24px;
  color: #fff;
  position: fixed;
  bottom: 140px;
  right: 55px;
}

 .tools-item cover-view {
  display: flex;
  align-items: center;
}
 .tools-item cover-image {
  width: 40px;
  margin: 0 12px 0 40px;
}
.kqb-share2 {
  opacity: 0.3;
  width: 100%;
  height: 100%;
  background-color: #333;
  position: fixed;
  bottom: 0px;
}
.bgC-white {
  background-color: #fff;
}
[class*="cuIcon1-"] {
  font-family: "myFont";
  font-size: inherit;
  font-style: normal;
}
.daoh {
  height: 50px;
  width: 50px;
  margin-left: 40px;
}
.shop-img {
  width: 140px;
  height: 140px;
  border-radius: 20px;
  margin: 0 10px 0 15px;
}
.cuIcon-locationfill:before {
    content: "\e650";
    font-size: inherit;
    font-style: normal;
}
.text-red, .line-red, .lines-red {
    color: #e54d42;
}
.co {
    color: #7eb0f7;
}
.text-gray, .line-gray, .lines-gray {
    color: #aaaaaa;
}
.swiper-img {
  width: 100%;
  height: 550px;
  border-radius:10px;
}




.bannerswipers {
  width: 100% !important;
  height: 500px;
  overflow: hidden;
}

.bannerswipers image {
  display: block;
}

/*用来包裹所有的小圆点  */

.bannerdots {
  width: auto;
  height: auto;
  display: flex;
  flex-direction: row;
  position: absolute;
  right: 30px;
  bottom: 20px;
}

/*未选中时的小圆点样式 */

.bannerdot {
  width: 16px;
  height: 16px;
  margin-right: 26px;
  background-color: #d1d1ce;
  border-radius: 16px;
}

.lunbo {
  height: 520px;
}
image {
 width: 100%;
 height: 500px;
  display: inline-block;
  position: relative;
  z-index: 0;
}
.touxiang{
  width: 80px;
  height: 80px;
}

.cu-item {
  text-align: center;
  display: inline-block;
  min-width: 160px !important;
  color: #999999;
  /* display: flex !important; */
  align-items: center !important;
  justify-content: center !important;
  font-size: 31px;
  font-weight: bolder;
}
/* 弹幕 */

.item-ranking {
  margin: 0 30px 30px 30px;
  border-radius: 30px;
}

.paihangimg {
  height: 60px;
  width: 60px;
  border-radius: 500px;
  margin: 0 10px 0 0;
  background-color: #4ecde4;
}

/* 划线价格 */
.huaxianjia {
  color: #ffffff;
  font-size: 24px;
  padding-top: 58px;
  text-decoration: line-through;
}

.xuanfu-tvimg {
  width: 130px;
  height: 125px;
  position: fixed;
  bottom: 460px;
  z-index: 3;
  right: 35px;
}

.on2::after {
  text-align: center;
  width: 170px;
  height: 8px;
  background-color: #3ea4f8;
  border-radius: 4px;
  content: "";
  position: absolute;
  top: 43px;
  display: flex;
  align-items: center;
  justify-content: center;
  left: 20px;
  opacity: 0.8;
  /* border-bottom: 2px solid #405cfd !important; */
}

.on {
  color: #000;
  font-size: 40px;

}
.time-box {
  font-size: 16px;
  color: #fff;
  border-radius: 20px;
  padding: 10px 5px;
  /* background: #fff; */
}

.time-item {
  width: 30px;
  height: 30px;
  border-radius: 4px;
  font-size: 20px;
  text-align: center;
  line-height: 40px;
  margin: 0 2px;
  background: #f7f5b4;
  color: #e70f0f;
}

.time-item1 {
  width: 30px;
  height: 40px;
  background: linear-gradient(90deg, #FFEBB1 0%, #FFDB8F 100%);
  border-radius: 4px;
  font-size: 24px;
  text-align: center;
  line-height: 40px;
  margin: 0 10px;
}
.bg-red {
    background-color: #e54d42;
    color: #ffffff;
}
.padding-lr-xs {
    padding-left: 12px;
    padding-right: 12px;
}

.justify-between {
    justify-content: space-between;
}

.text-red, .line-red, .lines-red {
    color: #e54d42;
}
.padding-tb-xs {
    padding-top: 12px;
    padding-bottom: 12px;
}
.text-df {
	font-size: 20px;
}
.padding-tb-sm {
	padding-top: 20px;
	padding-bottom: 20px;
}

.padding-tb {
	padding-top: 30px;
	padding-bottom: 30px;
}
.padding-lr {
	padding-left: 30px;
	padding-right: 30px;
}
.seamless-warp {
  height: 550px;
  overflow: hidden;
}
.zhuanshu {
    background-color: #f85959;
    padding: 7px 10px;
    border-radius: 35px;
    letter-spacing: 2px;
}
.text-white, .line-white, .lines-white {
    color: #ffffff;
}
.comp {
  font-size: 30px;
  margin: 20px 20px;
  align-items:center;
}

.dbg {
  background: url(/img/bg.jpg);
}
/* .nb-nodeboard-base .nb-nodeboard-contain-base .nb-nodeboard-top {
  background-color:#e54d42 !important;
} */
</style>
